module.exports = __webpack_public_path__ + "img/pantalla-2-2.f5ae31b6.png";